import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// TODO: Replace this URL with your deployed Google Sheets Apps Script Web App URL
const GOOGLE_SHEETS_HITS_URL = 'https://script.google.com/macros/s/AKfycbynPnm0tWszx4McNUHGpQkZ-QvzJRaidiHEwcwUb9fYlTRnO7Pk7xRF4ZG4bLBUTY-f/exec';

const getBrowserAndOS = () => {
  const ua = navigator.userAgent;
  let browser = 'Unknown';
  let os = 'Unknown';

  // Basic OS detection
  if (ua.indexOf('Win') !== -1) os = 'Windows';
  else if (ua.indexOf('Mac') !== -1) os = 'MacOS';
  else if (ua.indexOf('X11') !== -1) os = 'UNIX';
  else if (ua.indexOf('Linux') !== -1) os = 'Linux';
  else if (ua.indexOf('Android') !== -1) os = 'Android';
  else if (ua.indexOf('iPhone') !== -1 || ua.indexOf('iPad') !== -1) os = 'iOS';

  // Basic Browser detection
  if (ua.indexOf('Firefox') !== -1) browser = 'Firefox';
  else if (ua.indexOf('SamsungBrowser') !== -1) browser = 'Samsung Browser';
  else if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) browser = 'Opera';
  else if (ua.indexOf('Trident') !== -1) browser = 'Internet Explorer';
  else if (ua.indexOf('Edge') !== -1 || ua.indexOf('Edg') !== -1) browser = 'Edge';
  else if (ua.indexOf('Chrome') !== -1) browser = 'Chrome';
  else if (ua.indexOf('Safari') !== -1) browser = 'Safari';

  return { browser, os };
};

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Only track visits to the home page (/)
    if (location.pathname !== '/') return;

    // 1. Generate or retrieve Session ID
    let sessionId = sessionStorage.getItem('imat_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem('imat_session_id', sessionId);
    }

    // 2. Fetch or retrieve Geolocation data with a timeout so it never blocks tracking
    const getGeoInfo = () => {
      const cached = sessionStorage.getItem('imat_geo_info');
      if (cached) {
        return Promise.resolve(JSON.parse(cached));
      }

      return new Promise((resolve) => {
        const timeout = setTimeout(() => {
          console.warn('PageTracker: Geolocation fetch timed out after 800ms.');
          resolve({});
        }, 800);

        fetch('https://ipapi.co/json/')
          .then((res) => {
            if (!res.ok) throw new Error('API response not OK');
            return res.json();
          })
          .then((data) => {
            clearTimeout(timeout);
            sessionStorage.setItem('imat_geo_info', JSON.stringify(data));
            resolve(data);
          })
          .catch((err) => {
            clearTimeout(timeout);
            console.warn('PageTracker: Geolocation fetch failed:', err.message);
            resolve({});
          });
      });
    };

    const runTracker = async () => {
      const geoData = await getGeoInfo();
      const { browser, os } = getBrowserAndOS();

      const payload = {
        timestamp: new Date().toISOString(),
        sessionId: sessionId,
        path: location.pathname + location.search,
        referrer: document.referrer || 'Direct',
        ip: geoData.ip || 'Unknown',
        country: geoData.country_name || 'Unknown',
        city: geoData.city || 'Unknown',
        region: geoData.region || 'Unknown',
        browser: browser,
        os: os,
        screenResolution: `${window.screen.width}x${window.screen.height}`
      };

      console.log('PageTracker: Sending payload to Google Sheets:', payload);

      if (!GOOGLE_SHEETS_HITS_URL) {
        console.warn('PageTracker: GOOGLE_SHEETS_HITS_URL is empty.');
        return;
      }

      try {
        await fetch(GOOGLE_SHEETS_HITS_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        console.log('PageTracker: Fetch request executed (no-cors mode).');
      } catch (error) {
        console.error('PageTracker: Network error logging page hit:', error);
      }
    };

    runTracker();
  }, [location]);

  return null;
}
